<script>
  export default {
    name: 'configuracoes-main'
  }
</script>

<template>
  <router-view></router-view>
</template>

<style scoped>

</style>



// WEBPACK FOOTER //
// Main.vue?7d22da2a